import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLingui } from '@lingui/react/macro';

import type {
  ImageFinding,
  ImageFindingType,
} from '@/utils/claimSummary/imageFindings';

function useImageFindingLabel(type: ImageFindingType): string {
  const { t } = useLingui();
  switch (type) {
    case 'bitewing_overlap':
      return t`Overlap issue`;
    case 'missing_root_tips':
      return t`Missing root tips`;
    case 'cut_off_edges':
      return t`Cut off edges`;
    case 'missing_tooth':
      return t`Missing tooth`;
    case 'cej_not_visible':
      return t`CEJ not visible`;
    case 'missing_image':
      return t`Missing image`;
    default:
      return type;
  }
}

interface ImageFindingBadgeProps {
  findings: ImageFinding[];
}

export const ImageFindingBadge = ({ findings }: ImageFindingBadgeProps) => {
  const label = useImageFindingLabel(findings[0]?.type ?? 'missing_image');

  if (findings.length === 0) {
    return null;
  }

  const additionalCount = findings.length - 1;

  return (
    <div className="vai-flex vai-items-center vai-justify-start vai-gap-1 vai-w-full vai-bg-amber-500 vai-text-black vai-text-[10px] vai-font-medium vai-px-2 vai-py-0.5 vai-rounded-t">
      <FontAwesomeIcon
        icon={faTriangleExclamation}
        className="vai-w-2.5 vai-h-2.5"
      />
      <span>
        {label}
        {additionalCount > 0 && ` +${additionalCount}`}
      </span>
    </div>
  );
};
